module.exports = __webpack_public_path__ + "static/media/info.504aa45a.svg";